if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        // We always want the cart-drawer + bubble HTML back so we can
        // silently refresh them in the background, even though we will
        // not pop the drawer open over the page.
        const sectionsToRefresh = ['cart-drawer', 'cart-icon-bubble', 'main-cart-items', 'cart-live-region-text'];
        formData.append('sections', sectionsToRefresh.join(','));
        formData.append('sections_url', window.location.pathname);
        if (this.cart && typeof this.cart.setActiveElement === 'function') {
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            this.error = false;

            // === Visual feedback first — never let a background refresh
            //     failure rob the customer of their confirmation. ===
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              // The card that opened the quick-add modal handles its own
              // inline confirmation, so just close the modal here.
              try { quickAddModal.hide(true); } catch (_e) { /* non-fatal */ }
            } else {
              try { this._dbmShowAddedConfirmation(); }
              catch (e) { console.warn('[dbm] add-confirmation render failed', e); }
            }

            // === Background refreshes (each isolated). ===
            try { this._dbmRefreshCartDrawer(response); }
            catch (e) { console.warn('[dbm] cart-drawer refresh failed', e); }
            try { this._dbmRefreshCartBubble(response); }
            catch (e) { console.warn('[dbm] cart-bubble refresh failed', e); }

            try {
              if (typeof CartPerformance !== 'undefined' && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                }).then(() => {
                  CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                });
              }
            } catch (e) { console.warn('[dbm] cart-update publish failed', e); }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      _dbmRefreshCartDrawer(response) {
        if (!response || !response.sections || !response.sections['cart-drawer']) return;
        const drawer = document.querySelector('cart-drawer');
        if (!drawer) return;
        try {
          if (typeof drawer.getSectionInnerHTML === 'function' && typeof drawer.getSectionsToRender === 'function') {
            // Use the drawer's own renderer, but stop it from auto-opening.
            // cart-drawer.js calls `this.open()` from `renderContents` — guard
            // by stripping the `open` method temporarily. Safer fallback: parse
            // the section HTML and replace the inner CartDrawer body in place.
            const tmp = new DOMParser().parseFromString(response.sections['cart-drawer'], 'text/html');
            const newDrawer = tmp.querySelector('cart-drawer');
            if (newDrawer) {
              const newInner = newDrawer.innerHTML;
              drawer.innerHTML = newInner;
              if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
            }
          }
        } catch (e) { /* non-fatal */ }
      }

      _dbmRefreshCartBubble(response) {
        // Try the section payload first (faster, no extra request).
        if (response && response.sections && response.sections['cart-icon-bubble']) {
          const bubbleHost = document.querySelector('#cart-icon-bubble');
          if (bubbleHost) {
            const tmp = new DOMParser().parseFromString(response.sections['cart-icon-bubble'], 'text/html');
            const incoming = tmp.querySelector('.shopify-section') || tmp.body;
            if (incoming) bubbleHost.innerHTML = incoming.innerHTML;
          }
        }
        // Authoritative item_count comes from /cart.js — used to keep
        // the custom .dbm-badge / mobile bottom-nav badge in sync.
        fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', {
          headers: { Accept: 'application/json' },
        })
          .then((r) => (r.ok ? r.json() : null))
          .then((cart) => {
            if (!cart) return;
            const count = Math.min(cart.item_count, 99);
            document.querySelectorAll('.dbm-badge').forEach((el) => {
              el.textContent = String(count);
              el.style.display = cart.item_count === 0 ? 'none' : '';
            });
            document.querySelectorAll('[data-mobile-cart-count]').forEach((el) => {
              el.textContent = String(count);
              if ('hidden' in el) el.hidden = cart.item_count === 0;
            });
          })
          .catch(() => {});
      }

      _dbmShowAddedConfirmation() {
        const btn = this.submitButton;
        const span = this.submitButtonText;
        if (!btn || !span) return;
        const original = btn.dataset.dbmOriginalLabel || span.textContent.trim();
        btn.dataset.dbmOriginalLabel = original;

        btn.classList.add('dbm-added');
        span.innerHTML = '<svg class="dbm-added__check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" aria-hidden="true"><path d="m5 12 5 5L20 7"/></svg>Added to basket';

        // Insert the persistent "View basket" link if not yet present
        const buttonsWrap = btn.closest('.product-form__buttons') || btn.parentElement;
        if (buttonsWrap) {
          const productForm = buttonsWrap.closest('.product-form') || buttonsWrap.parentElement;
          let viewLink = productForm && productForm.querySelector('.dbm-view-basket-link');
          if (!viewLink) {
            viewLink = document.createElement('a');
            viewLink.className = 'dbm-view-basket-link';
            viewLink.href = (window.routes && window.routes.cart_url) || '/cart';
            viewLink.innerHTML = 'View basket <span aria-hidden="true">&rarr;</span>';
            buttonsWrap.insertAdjacentElement('afterend', viewLink);
          }
          // Pulse it so it draws the eye on repeat adds
          viewLink.classList.remove('is-pulsing');
          // Force reflow so the animation restarts on repeat clicks
          // eslint-disable-next-line no-unused-expressions
          viewLink.offsetWidth;
          viewLink.classList.add('is-pulsing');
        }

        clearTimeout(this._dbmRevertTimer);
        this._dbmRevertTimer = setTimeout(() => {
          btn.classList.remove('dbm-added');
          span.textContent = original;
        }, 3000);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
